module.exports = __webpack_public_path__ + "static/img/VN@3x.c6be955f.jpg";